import { h } from 'preact';
import React from 'react';
import { convertClassName } from '../../util';
import * as components from '../../Components/privacyManagerComponents';

const Children = (props) => {
  return props.components.map((component, index) => {
    const CustomComponent = components[component.type];
    const path = [...props.path];
    path.push(index);
    return (
      <CustomComponent
        path={path}
        dev={props.dev}
        key={'n-' + path}
        component={component}
        className={convertClassName(component.handle)}
        siteId={props.siteId}
        vendorListId={props.vendorListId}
        message={props.message}
        language={props.language}
        makeChoice={props.makeChoice}
        togglePurposeOrFeature={props.togglePurposeOrFeature}
        toggleVendor={props.toggleVendor}
        toggleStack={props.toggleStack}
        width={props.width}
        pmData={props.pmData}
        pmTab={props.pmTab}
        events={props.events}
        preview={props.preview}
        idfaStatus={props.idfaStatus}
        neutralPm={props.neutralPm}
        allSelectionsMade={props.allSelectionsMade}
        shown={props.shown}
      />
    );
  });
}

export default Children;